<template>
	<div>
		<div class="results">
			<div v-if="!embedded" class="sort-bar">
				<div class="displaying">
					Showing <strong>{{ numOnDisplay }}</strong> of <strong>{{ results.length }}</strong> result<span v-if="results.length > 1">s</span>
				</div>
				<sort></sort>
			</div>
			<div class="results-grid">
				<result v-if="promotionalResults.length > 0" :key="'promo-' + key" v-for="(promotionalResult, key) in promotionalResults" :result="promotionalResult"></result>
				<result v-for="(result, index) in displayedResults" :result="result" :key="index"></result>
			</div>
		</div>
		<div v-if="!embedded" class="navigation">
			<div class="page-total">
				Items per page
				<select v-model="perPage" @change="currentPage = 1">
					<option v-for="option in pageOptions" :value="option">{{ option }}</option>
				</select>
			</div>
			<div class="page-count">Page {{ currentPage }} of {{ maxPages }}</div>
			<div class="page-nav">
				<span v-if="currentPage > 2" @click="currentPage = 1; $emit('scrollToTop');">First</span>
				<span v-if="currentPage !== 1" @click="currentPage--; $emit('scrollToTop');">&lt;&lt;</span>
				<span class="nav-active">{{ currentPage }}</span>
				<span v-for="pageNumber in pages.slice(currentPage, currentPage + 2)" @click="currentPage = pageNumber; $emit('scrollToTop');">{{pageNumber}}</span>
				<span @click="currentPage++; $emit('scrollToTop');" v-if="currentPage < pages.length">&gt;&gt;</span>
				<span v-if="pages.length > 2" @click="currentPage = maxPages; $emit('scrollToTop');">Last</span>
			</div>
		</div>
	</div>
</template>

<script>
import Result from './Result';
import Sort from './Sort';

export default {
	data() {
		return {
			currentPage: 1,
			perPage: 8,
			pageOptions: [8, 12, 20],
		}
	},
	props: {
		maxResults: {
			type: String,
			default: 1000
		},
		promotionalResults: {
			type: Array,
			required: false,
			default: () => [],
		},
		embedded: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		/**
		 * Fetches cruise results with filters applied.
		 *
		 * @returns {Array} All cruise results.
		 */
		results () {
			return this.$store.getters.results.filter(({cruises}) => this.promotionalResults.filter(promoResult => promoResult.cruises[0].route.id === cruises[0].route.id).length === 0).slice(0, (this.maxResults - this.promotionalResults.length));
		},
		/**
		 * Organise the results into pages.
		 *
		 * @returns {Array} Pages
		 */
		pages()
		{
			const pages = [];
			for (let index = 1; index <= this.maxPages; index++)
				pages.push(index);

			return pages;
		},
		/**
		 * Calculate the max number of pages needed to fit all results.
		 *
		 * @returns {number} The total number of pages.
		 */
		maxPages()
		{
			return this.results.length
				? Math.ceil(this.results.length / this.perPage)
				: 0;
		},
		/**
		 * Paginate the results based on the selected 'per page'.
		 *
		 * @returns {Array} The results to display.
		 */
		displayedResults () {
			let from = (this.currentPage * this.perPage) - this.perPage;
			let to = this.currentPage * this.perPage;
			return this.results.slice(from, to);
		},
		/**
		 * Calculate the number of results currently shown.
		 *
		 * @returns {string|number} String if there are more results than fit on the page, otherwise just the number.
		 */
		numOnDisplay() {
			if (this.results.length <= 4)
				return this.results.length;

			let firstShown = (this.perPage * (this.currentPage - 1)) + 1;
			let lastShown = this.perPage * this.currentPage;

			if (lastShown > this.results.length)
				lastShown = this.results.length;

			return firstShown + ' - ' + lastShown;
		},
	},
	components: {
		Result,
		Sort,
	}
}
</script>

<style lang="scss">
.results-grid {
	@media (min-width: 992px) {
		display: grid;
		grid-template-columns: 48% 48%;
		justify-content: space-between;
	}
}

.navigation {
	display: flex;

	.page-nav {
		font-weight: bold;

		span {
			padding: 0 5px;
			cursor: pointer;
		}

		.nav-active {
			border-bottom: 1px solid black;
			cursor: default;
		}
	}

	@media (max-width: 670px) {
		display: block;
		text-align: center;

		.page-total {
			padding-bottom: 5px;
		}

		.page-count {
			padding-bottom: 5px;
		}
	}

	@media (min-width: 671px) {
		border-top: 1px solid black;
		border-bottom: 1px solid black;
		padding: 20px 0 !important;

		.page-total {
			width: 33%;
			padding: 0;
		}

		.page-count {
			width: 33%;
			padding: 0;
			text-align: center;
		}

		.page-nav {
			width: 33%;
			text-align: right;
			padding: 0;
		}
	}
}

.sort-bar {
	margin: 20px 0;

	@media (min-width: 992px) {
		padding: 0 15px;
	}

	@media (max-width: 480px) {
		font-size: 12px;
	}
}

.displaying {
	padding: 4px;
	margin: 2px;
	float: left;
}
</style>
